import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
// import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, WorkOrderService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";

@Component({
  selector: "party-tab",
  // host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./rackAllocation.html",
})
export class rackAllocation implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  rackList: any[];
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "order_from",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];
 selected = [];
  filterExpand = false;

  agentList$ = [];
  companyInfo: any = [];
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  constructor(
    private finyearService: FinyearService,
    public store: Store<fromRootStore.State>,
    private Woservice: WorkOrderService,
    public toasterService: ToasterService
  ) {
    this.filter = {
      wh_code: "",
      line_no: '',
      location_code: '',
      rack_name: "",
      bay_from: '',
      bay_to: '',

    };
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;*/
  }

  ngOnInit(): void {


 this.columns = [
      //  {
      //     prop: "selected",
      //     name: "",
      //     sortable: false,
      //     canAutoResize: false,
      //     draggable: false,
      //     resizable: false,
      //     headerCheckboxable: true,
      //     checkboxable: true,
      //     width: 30,
      //   },
    {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
        name: "Style",
        prop: "style",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
        {
        name: "Type",
        prop: "type",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
        {
        name: "Variety",
        prop: "variety",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
        {
        name: "Design",
        prop: "design",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
     {
        name: "WH Code",
        prop: "warehouse",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
         {
        name: "Line From",
        prop: "line_start",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Line To",
        prop: "line_end",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Rack From",
        prop: "rack_start",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
        {
        name: "Rack To",
        prop: "rack_end",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
             
      
      {
        name: "Allocate Qty",
        prop: "allocated_qty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
    // this.applyFilter();
  }

  // hotkeys(event) {
  //   if (this.active) {
  //     if (event.ctrl && event.keyCode === 13) {
  //       this.addEditSeason("Add", "");
  //     }
  //     if (event.keyCode === 27) {
  //       this.bsModalRef.hide();
  //     }
  //   }
  // }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getrackList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getrackList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getrackList();
  }

 

  getrackList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 0)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wh_code: this.filter.wh_code,
      line_no: this.filter.line_no,
      location_code: this.filter.location_code,
      rack_name: this.filter.rack_name,
      bay_from: this.filter.bay_from,
      bay_to: this.filter.bay_to
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.Woservice
      .getrackAllocationList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.rackList = res.data;

      });
  }

  clearFilter(): void {
    this.filter = {
      wh_code: "",
      line_no: '',
      location_code: '',
      rack_name: "",
      bay_from: '',
      bay_to: '',
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getrackList();
  }


  addEditSeason(mode: string, row: any): void {
         
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getrackList();
    });

    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD RACK ALLOCATION",
          title: "ADD RACK ALLOCATION",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "ADD RACK ALLOCATION",
        },
      };
    }
   else if (mode == "Edit") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "EDIT RACK ALLOCATION",
          title: "EDIT RACK ALLOCATION",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "EDIT RACK ALLOCATION",
        },
      };
    }
    
    this.tabUpdateEvent.emit(tabObj);
  }
   printRow(row){
      this.selected = [];
      this.selected.push({ ...row })
      this.Barcodeprint();
  }

  Barcodeprint() {
    if (!this.selected.length) {
      swal("ERROR", "Pls select atleast One!!", "error")
      return
    }

    let params: any = {}
    let data = this.selected.map(item => ({ item: 'RACK', barcode: item.location_code, whCode: item.wh_code}));
    params['data'] = JSON.stringify(data)
    let that = this;
    this.Woservice.bagBarcodeprint(params).then(function (res: any) {
      if (res.success) {
        that.selected.splice(0, that.selected.length);
         that.getrackList();
        that.toasterService.pop({
          bodyOutputType: 1,
          type: "success",
          title: "success".toUpperCase(),
          body: "PRINTED SUCCESSFULLY",
        });
      }
     })

  }




  finyearFn(season: number) {
    let list: any = [];
    let that = this;
    list = this.finyearList;

    let id = season && season ? season : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });

      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }
   onSelect({ selected }, ind) {

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
 

  }

  deleteRackDetails(row): void {

    let params = {
      requestId: row.id
    };
    let that = this;
    swal({
      title: "Are you sure to delete",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.Woservice
          .deleteRackAllocateDetails(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
         
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }
            else {
            that.getrackList();
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        /*if (dismiss === 'cancel') {
              swal(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }*/
      }
    );
  }

  addEditDetails(mode: string): void {
    let row = {
      sp_id: 1,
      fin_id: 1,
      sales_target: 4000,
      order_per: 50,
      order_target: 8000,
      fin_year: "2015-2016",
    };
    let tabObj = {
      action: "NewTab",
      params: {
        tabParent: "Master",
        tabName: "PlandetailsMasterComponent",
        mode: mode,
        data: row,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/RackAllocation/rackAllocation.ts